
import React from "react";
import { Check, X } from "lucide-react";

export const TariffSuccess: React.FC<{
  showCheck: boolean;
  sentTariff: { title: string; price: number } | null;
  clientNumber: string | null | undefined;
  error?: boolean; // Добавляем флаг ошибки
  dealNumber?: string; // Добавляем номер сделки
}> = ({ showCheck, sentTariff, clientNumber, error = false, dealNumber }) => (
  <div className="min-h-[480px] flex flex-col justify-center items-center text-center text-white animate-fade-in py-12 px-4 sm:px-8 bg-gradient-to-br from-green-600 via-violet-800 to-violet-900 rounded-3xl shadow-2xl relative w-full max-w-md mx-auto">
    {/* Исправлено позиционирование иконки: убран overlap */}
    {showCheck && (
      <div
        className={`
          rounded-full w-24 h-24 shadow-2xl flex items-center justify-center animate-scale-in z-20 border-4 mb-8
          ${error ? "bg-red-600 border-red-500" : "bg-white border-green-500"}
        `}
      >
        {error ? (
          <X size={56} color="#ea384c" strokeWidth={4} className="animate-scale-in" />
        ) : (
          <Check size={56} color="#20d148" strokeWidth={4} className="animate-scale-in" />
        )}
      </div>
    )}

    <div className="mb-2 flex flex-col items-center justify-center">
      <span className={`text-[2rem] font-extrabold leading-tight mb-1 px-4 py-1 rounded-xl ${error ? "text-red-400 bg-white/[0.12]" : "text-green-300 bg-white/[0.12]" } drop-shadow-xl`}>
        {error ? "Ошибка отправки!" : "Заявка отправлена!"}
      </span>
      <span className="text-md font-medium mb-3 mt-1 text-white/90">
        {error ? "Проверьте соединение и попробуйте еще раз." : "Мы уже обрабатываем вашу заявку"}
      </span>
    </div>
    {sentTariff && !error && (
      <div className="flex flex-col gap-1 bg-white/[0.15] rounded-2xl p-4 pb-5 min-w-[240px] max-w-[310px] mx-auto border border-white/30 shadow-md">
        <div className="flex justify-between mb-1 text-base sm:text-lg">
          <span className="text-gray-100">Тариф:</span>
          <span className="font-bold text-white">{sentTariff.title}</span>
        </div>
        <div className="flex justify-between mb-1 text-base sm:text-lg">
          <span className="text-gray-100">Сумма:</span>
          <span className="font-bold text-white">{sentTariff.price.toLocaleString()}₽</span>
        </div>
        <div className="flex justify-between mt-1 pt-2 border-t border-dashed border-white/20 text-[0.92rem]">
          <span className="text-gray-100">Номер заявки:</span>
          <span className="font-mono font-medium text-white">{dealNumber || clientNumber || "N/A"}</span>
        </div>
      </div>
    )}
    {!error && (
      <div className="mt-6 text-base flex items-center gap-2 text-green-200">
        <div className="w-2 h-2 rounded-full bg-green-400 animate-pulse" />
        Ожидайте звонка менеджера!
      </div>
    )}
  </div>
);
